module.exports = __webpack_public_path__ + "img/rwa.7fe5146b.svg";